export default "__VITE_ASSET__BBE$C6wr__"